import React, { useState } from "react";

import EquipBidHeader from "../../Components/EquipbidHeader";
import { demoAdsListingData } from "../../Utils/dummyData";

import AddListing from "./AdsListing";

export const SearchResult = () => {
  const [adsListingData, setAdsListingData] = useState(demoAdsListingData);

  const [selectedHeaderTab, setSelectedHeaderTab] = useState("");

  const [filterSelectedData, setFilterSelectedData] = useState({
    tabs: ["Equipment"],
    category: ["Aggegate Equipment1"],
    makes: ["one", "two"],
  });

  const [stepperState, setStepperState] = useState(0);

  return (
    <>
      <EquipBidHeader setSelectedHeaderTab={setSelectedHeaderTab} filterSelectedData={filterSelectedData} setFilterSelectedData={setFilterSelectedData} setStepperState={setStepperState} showHeaderBottom={false} />

      <div id="filter-page-container">
        <div className="filter-section"></div>

        <div className="listing-section">
          {adsListingData.length > 0 ? adsListingData.map((_list, idx) => (
            <div>
              <AddListing
                image={_list.image ?? "-"}
                title={_list.title ?? "-"}
                distance={_list.distance ?? "-"}
                city={_list.city ?? "-"}
                description={_list.description ?? "-"}
              />
            </div>
          )) : <p>No ads list available</p>}
        </div>

        <div className="right-section"></div>
      </div>
    </>
  );
};
